import SimulationPlanApi from '@/api/SimulationPlan'

export class SimulationPlanRepository {
  static async getSimulationList(
    accountId,
    advertiserId,
    keyword,
    menuType,
    pageNo,
    pageSize,
    sortOptions,
  ) {
    try {
      const res = await SimulationPlanApi.search(
        accountId,
        advertiserId,
        keyword,
        menuType,
        pageNo,
        pageSize,
        sortOptions,
      )
      return res
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async findById(simulationId) {
    try {
      return SimulationPlanApi.findById(simulationId)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async findByHashId(hashId) {
    try {
      return SimulationPlanApi.findByHashId(hashId)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async create(form) {
    try {
      return SimulationPlanApi.create(form)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async update(simulationId, form) {
    try {
      return SimulationPlanApi.update(simulationId, form)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async delete(simulationId) {
    try {
      return SimulationPlanApi.delete(simulationId)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async makeHashId(simulationId) {
    try {
      return SimulationPlanApi.makeHashId(simulationId)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
